import { useAuth } from "../contexts/AuthProvider";
import { useChosenDepartment } from "../contexts/ChosenDepartment";

/**
 * Whether the signed-in admin can't write to the chosen department. Mirrors the backend's `is_readonly_for_department`.
 * Both flags are checked because the account-wide one only reflects the leading department.
 */
export const useIsReadOnlyForDepartment = (): boolean => {
	const { userInfo } = useAuth();
	const { chosenDepartment } = useChosenDepartment();
	const currentDept = userInfo?.departments?.find((dept) => dept.department_id === chosenDepartment.department_id);
	return userInfo?.is_read_only === true || currentDept?.is_readonly === true;
};
